import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import ShortcutPalette from "./ShortcutPalette";
import CommandPaletteSearch from "./CommandPaletteSearch";
import { useAuth } from "@/lib/auth";

export default function AppLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-950">
        <div className="mono text-zinc-500 text-sm">Loading trading terminal…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="flex min-h-screen bg-[#09090b] text-white">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
      {/* Global keyboard shortcut palette — mounted here so it lives on
          every authenticated page but stays out of the landing/auth flow. */}
      <ShortcutPalette />
      <CommandPaletteSearch />
    </div>
  );
}
